import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  envName: 'local' | 'local-api' | 'dev' | 'azure.dev' | 'azure.qa' | 'azure.uat' | 'azure.prod' | 'qa' | 'uat' | 'prod';
  production: boolean;
  baseUrl: string;
  /**
   * Base url for accessing Clear 1
   */
  clear1HostUrl: string;
  /**
   * Base url for accessing Clear 2 Docs
   */
  clear2DocsUrl: string;
  clear2DocsHostUrl: string;
  retail: {
    baseUrl: string;
    autoRecoveryIntervalMs: number;
    apiUrl: string;
    enableAutoRecovery: boolean;
    maxAutoRecoveryAttempts: number;
    /** How long to wait before going to pipeline, after lead creation */
    newLoanRefreshDelayMS: number;
    /** Polling interval for active users file change detection (in milliseconds) */
    activeUsersPollingIntervalMs: number;
    /** HTTP fallback polling interval for active users (in milliseconds) - safety net for missed SignalR messages */
    activeUsersHttpFallbackIntervalMs: number;
    /** Heartbeat interval for active users (in milliseconds) - safety net for missed OnDisconnectedAsync events */
    activeUsersHeartbeatIntervalMs: number;
    /** Join notification throttle window (in milliseconds) - buffers rapid joins to reduce toast spam */
    activeUsersJoinThrottleMs: number;
  };
  rules: {
    rulesApiUrl: string;
    rulesHubUrl: string;
    isLiteMode: boolean;
    bearerToken: string;
  };
  licenses: {
    /** For AG Grid - Enterprise version. */
    agGrid: string;
  };
  logoutWarning: {
    isActive: boolean;
    secondsInactivity: number;
    secondsWindowCountdown: number;
  };
  auth: {
    /** Whether to use the Azure Active Directory SSO (via MSAL) for auth purposes. */
    useAzureAD: boolean;
    clientId: string;
    tenantId: string;
    scopes: string[];
  };
  logRocket: {
    enabled: boolean;
    applicationId: string;
  };
  appInsights: {
    applicationName: string;
    connectionString: string;
    excludedRegexes: string[];
  };
  featureFlagPollingDelay: number;
  versionUpdatePollingDelay: number;
  serviceWorkerEnabled: boolean;
  serviceWorkerRegistrationDelay: number;
  securityProfileId: {
    Admin: number;
    SuperDisclosureLO: number;
    DisclosureLO: number;
    DisclosurePA: number;
    SuperDisclosurePA: number;
    SuperDisclosureLORelo: number;
    AdminLaptop: number;
    DisclosureCoordinator: number;
    ProductionAssistant: number;
  };
  enableAmcProviderForDivision: string;
  /** Configuration for partner co-branding features. */
  partners: {
    coBrandingApplicationBaseUrl: string;
  };
  /** URL for the Clear AI Hub portal */
  clearAiHubUrl: string;
}

export const APP_ENV = new InjectionToken<EnvironmentConfig>('APP_ENV');
